/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconGoldBar: {
  name: 'gold_bar';
  data: string;
} = {
  name: 'gold_bar',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M222.839 368.069 222.813 368.055 222.714 368.003z"/><path d="m586.583 307.873-42.205-111.669-153.427-83.401L73.023 282.277 26.526 406.498l187.421 99.727 3.073-135.152-145.804-83.258 12.505 6.619-7.138-4.104 25.482 13.544-23.17-13.544 143.918 77.725.026.014 309.926-160.19-49.607 27.23 58.078-29.664-114.952 60.883-199.552 109.536-12.785 130.361 372.636-198.352zm-357.551 21.183-83.94-44.786 81.64 25.244 249.966-110.919-247.666 130.461z"/></svg>`,
};
